/* --------------------------------------------------------------------------------------
   appProvider.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/
import { createContext } from "preact";
import JobSettingsProvider from "./jobSettingsProvider";
import ValidationProvider from "./validationProvider";
import ScanQueuesProvider from "./scanQueuesProvider";

export const appContext = createContext()

const AppProvider = ({ children }) => {

    return <appContext.Provider value={null}>
        <JobSettingsProvider>
            <ScanQueuesProvider>
            <ValidationProvider>{children}</ValidationProvider>
            </ScanQueuesProvider>
        </JobSettingsProvider>
    </appContext.Provider>
}

export default AppProvider